import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

export default class DateSelectComponent extends React.Component {
  constructor(props) {
    super(props);
    this.dateId = `${Math.round(Math.random() * 10 ** 10)}`;
  }

  handleChange = date => {
    console.debug("DATE VALUE", date, moment(date), moment(date).format("L"));
    const newFormatDate = moment(date).format("L");
    this.props.onDateChange(newFormatDate);
  };

  render() {
    const { id, value, editable } = this.props;
    return (
      <DatePicker
        // className={editable === true ? "datebackground" : ""}
        id={id || this.dateId}
        selected={moment(value)}
        disabled={!editable}
        // dateFormat="DD-MM-YYYY"
        onChange={this.handleChange}
        data-test="dateselectcomponent-datepicker"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/CustomGridTypeComponents/DateSelectComponent.js